import * as tslib_1 from "tslib";
import { makeGetRequest } from 'owa-ows-gateway';
var getPremiumUserUrl = 'ows/api/beta/PremiumUser/';
export function getPremiumUser() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var response;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, makeGetRequest(getPremiumUserUrl)];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response];
            }
        });
    });
}
//# sourceMappingURL=getPremiumUser.js.map